import { Link } from 'react-router-dom'

export default function Privacy() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-primary-600 text-white py-16">
        <div className="container mx-auto px-6">
          <Link to="/" className="text-white hover:text-primary-100 mb-4 inline-block">
            ← Back to Home
          </Link>
          <h1 className="text-4xl font-bold mt-4">Privacy Policy</h1>
          <p className="text-primary-100 mt-2">Last updated: March 2024</p>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 shadow-sm">
          <div className="prose prose-lg">
            <h2>1. Information We Collect</h2>
            <h3 className="text-xl font-semibold mt-4 mb-2">Personal Information:</h3>
            <ul className="list-disc pl-6 mb-4 text-gray-600">
              <li>Name and contact information (email, phone)</li>
              <li>Company details and job title</li>
              <li>Account credentials</li>
              <li>Billing information</li>
            </ul>

            <h3 className="text-xl font-semibold mt-4 mb-2">Usage Information:</h3>
            <ul className="list-disc pl-6 mb-6 text-gray-600">
              <li>IP address and device information</li>
              <li>Browser type and settings</li>
              <li>Pages viewed and features used</li>
              <li>Email campaign performance data</li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <p className="text-gray-600 mb-4">We use your information to:</p>
            <ul className="list-disc pl-6 mb-6 text-gray-600">
              <li>Provide and improve our services</li>
              <li>Process payments and manage your account</li>
              <li>Send important notifications and updates</li>
              <li>Analyze usage patterns to enhance user experience</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2>3. Data Sharing and Disclosure</h2>
            <p className="text-gray-600 mb-4">We may share your information with:</p>
            <ul className="list-disc pl-6 mb-6 text-gray-600">
              <li>Service providers who assist in operating our platform</li>
              <li>Payment processors for billing purposes</li>
              <li>Law enforcement when required by law</li>
            </ul>
            <p className="text-gray-600 mb-6">We do not sell your personal information to third parties.</p>

            <h2>4. Data Security</h2>
            <p className="text-gray-600 mb-6">
              We implement industry-standard security measures to protect your information, including 
              encryption, secure servers, and regular security audits. However, no method of transmission 
              over the Internet is 100% secure.
            </p>

            <h2>5. Your Rights</h2>
            <p className="text-gray-600 mb-4">You have the right to:</p>
            <ul className="list-disc pl-6 mb-6 text-gray-600">
              <li>Access your personal information</li>
              <li>Correct inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of marketing communications</li>
              <li>Export your data</li>
            </ul>

            <h2>6. Cookies and Tracking</h2>
            <p className="text-gray-600 mb-6">
              We use cookies and similar technologies to enhance your experience, analyze trends, 
              and administer the website. You can control cookies through your browser settings.
            </p>

            <h2>7. Third-Party Services</h2>
            <p className="text-gray-600 mb-6">
              Our service may contain links to third-party websites. We are not responsible for their 
              privacy practices. We encourage you to read their privacy policies.
            </p>

            <h2>8. Children's Privacy</h2>
            <p className="text-gray-600 mb-6">
              Our service is not intended for users under the age of 13. We do not knowingly collect 
              information from children under 13.
            </p>

            <h2>9. International Data Transfers</h2>
            <p className="text-gray-600 mb-6">
              Your information may be transferred to and processed in countries other than your own. 
              We ensure appropriate safeguards are in place for such transfers.
            </p>

            <h2>10. Changes to Privacy Policy</h2>
            <p className="text-gray-600 mb-6">
              We may update this policy periodically. We will notify you of significant changes via 
              email or through our service.
            </p>

            <h2>11. Contact Us</h2>
            <p className="text-gray-600 mb-4">
              For privacy-related questions or concerns, please contact our Data Protection Officer:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-600">Email: privacy@emailaipro.com</p>
              <p className="text-gray-600">Address: 123 Innovation Drive, San Francisco, CA 94105</p>
              <p className="text-gray-600">Phone: (555) 123-4567</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-8">
        <div className="container mx-auto px-6 text-center text-gray-500">
          <p>&copy; 2024 EmailBrain. All rights reserved.</p>
        </div>
      </footer>
    </div>
  )
}